import React, { SyntheticEvent, useEffect } from 'react';

import { Helmet } from 'react-helmet';
import { useLocation, useParams } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Container, Stack, Typography } from '@mui/material';

import SectionNavigation from '~/components/Common/Elements/SectionNavigation';
import SectionNavigationLayout from '~/components/Common/Elements/SectionNavigationLayout';

import useAppNavigation from '~/hooks/useAppNavigation';

import TripPlannerChatTracePage from './TripPlannerChatTracePage';
import { tripPlannerChatTabs } from './tripPlannerChatTabs';

export default function TripPlannerChatPage() {
  const { push, replace } = useAppNavigation();
  const location = useLocation();
  const { chatId } = useParams<{ chatId?: string }>();

  const currentTab = tripPlannerChatTabs.find((tab) => tab.path === location.pathname) ?? tripPlannerChatTabs[0];
  const chatListParams = new URLSearchParams(location.search);
  chatListParams.delete('turnId');
  chatListParams.delete('messageId');
  const tripsTabPath = tripPlannerChatTabs[0]?.path ?? '';

  const handleTabChange = (_event: SyntheticEvent, newValue: string) => {
    push({
      pathname: newValue,
      search: newValue === tripsTabPath ? location.search : '',
    });
  };
  const CurrentTabComponent = currentTab.component;
  const pageTitle = chatId ? 'Trace' : currentTab.title;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (!chatId || !searchParams.has('chatId')) {
      return;
    }
    searchParams.delete('chatId');
    replace({ pathname: location.pathname, search: searchParams.toString(), hash: location.hash }, location.state);
  }, [chatId, location.pathname, location.search, location.hash, location.state, replace]);

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>TripPlanner - Chat - {pageTitle}</title>
      </Helmet>

      {chatId ? (
        <TripPlannerChatTracePage
          renderHeader={(actions) => (
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              gap={1}
              sx={{ py: 1.5, borderBottom: 1, borderColor: 'divider' }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                size="small"
                sx={{ textTransform: 'none' }}
                onClick={() => push({ pathname: tripsTabPath, search: chatListParams.toString() })}
              >
                Chats
              </Button>
              <Typography variant="subtitle2" sx={{ borderLeft: 1, borderColor: 'divider', pl: 2, mr: 1 }}>
                Chat {chatId}
              </Typography>
              <Box sx={{ ml: 'auto' }}>{actions}</Box>
            </Stack>
          )}
        />
      ) : (
        <SectionNavigationLayout
          navigation={
            <SectionNavigation
              label="TripPlanner sections"
              currentTab={currentTab.path}
              groups={[
                {
                  items: tripPlannerChatTabs.map((tab) => ({
                    id: tab.path,
                    label: tab.title,

                    href: tab.path,
                  })),
                },
              ]}
              onSelect={(event, id) => {
                event.preventDefault();
                handleTabChange(event, id);
              }}
            />
          }
        >
          <CurrentTabComponent />
        </SectionNavigationLayout>
      )}
    </Container>
  );
}
